import { render, staticRenderFns } from "./_name.vue?vue&type=template&id=512a0a1a&scoped=true&"
import script from "./_name.vue?vue&type=script&lang=js&"
export * from "./_name.vue?vue&type=script&lang=js&"
import style0 from "./_name.vue?vue&type=style&index=0&lang=css&"
import style1 from "./_name.vue?vue&type=style&index=1&id=512a0a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512a0a1a",
  null
  
)

export default component.exports